import React, { forwardRef } from "react";
import { FieldTypes } from "utils/formUtils";

import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import socketDevMappingForm from "./SocketDevMappingForm";

interface GenericPullCredentialsFormProps {
  fields: { name: string; label: string; required: boolean; type?: string }[];
  versionField: boolean;
  MappingForm: React.ComponentType<any>;
}

const SocketDevCredentialsForm: React.ForwardRefRenderFunction<
  GenericPullCredentialsFormProps,
  any
> = (props, ref) => {
  const fields: {
    name: string;
    label: string;
    required: boolean;
    type?: string;
  }[] = [
    {
      name: "organisation",
      label: "Organisation",
      required: true,
    },
    {
      name: "apiToken",
      label: "API Token",
      type: FieldTypes.PASSWORD,
      required: true,
    },
    {
      name: "apiEndpoint",
      label: "Endpoint",
      required: true,
    },
  ];

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      versionField={false}
      MappingForm={socketDevMappingForm as React.ComponentType<any>}
    />
  );
};

export default forwardRef(SocketDevCredentialsForm);
